/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Link request for deposit vault, network connection or external wallet.
 */
export interface LinkRequest {
  /**
   * Deposit vault, network connection or external wallet ID.
   */
  id: number;
  /**
   * NUll if unlink case.
   */
  accountId?: number;
}
